import i18next from "i18next";
import React, { useEffect } from "react";
import { ArrowRight } from "react-feather";
import { useNavigate, useLocation } from "react-router-dom";

const HeaderBar = ({
  title,
  content,
  isBack,
  isEdit,
  setSelectedLangCode,
  selectedLangCode,
  dataTestId ,
  indexPath ,
  page
}) => {
  const navigate = useNavigate();
  const location = useLocation();
     const from = location.state?.from;
    const tab = location.state?.tab;
  
 console.log('from', from)

  useEffect(() => {
    if (isEdit) {
      const currentLang = i18next.language;
      setSelectedLangCode(currentLang);
    }
  }, [isEdit, setSelectedLangCode]);

  const handleBack = () => {
 
 console.log('from', from)
  if (from) {
    const url = new URL(window.location.origin + from);
    const params = new URLSearchParams(url.search);

    if (page) {
      params.set("page", page); // replaces page instead of appending
    }
console.log('url', url)
    navigate(`${url.pathname}?${params.toString()}`, {
      state: { tab },
    });
  }
  else if (indexPath) {
    navigate(indexPath ,{
      state:{ tab:indexPath.includes("/stores")?"stores": tab }
    });
  }else {
    navigate(-1);
  }
  };

  const handleChange = (e) => {
    setSelectedLangCode(e.target.value);
  };

  return (
    <header className="mb-4 d-flex gap-5" data-test-id={dataTestId}>
      <div className="d-flex">
        {isBack && (
          <button className="btn" onClick={handleBack}>
            <ArrowRight />
          </button>
        )}

        <div>
          <h3 className="fw-bold">{title}</h3>
          <p className="text-muted fs-5">{content}</p>
        </div>
      </div>

      <div className="m-auto">
        {isEdit && (
          <select
            className="form-select"
            onChange={handleChange}
            value={selectedLangCode}
          >
            <option value="ar">العربية</option>
            <option value="en">الإنجليزية</option>
          </select>
        )}
      </div>
    </header>
  );
};

export default HeaderBar;